"use client";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";

interface BrandHeroTitleProps {
  /** Desktop — natural wrap at 560px (Figma 7231:32281). */
  title: string;
  /** Mobile line 1 — explicit break (Figma 7231:32279). */
  titleLine1: string;
  /** Mobile line 2. */
  titleLine2: string;
}

/**
 * Brand guidelines hero headline — mobile uses an explicit two-line break;
 * desktop uses natural wrap so "Everything that" / "makes us Wayflyer" flows
 * at 560px without a forced newline (same pattern as HomeHeroTitle).
 */
export function BrandHeroTitle({
  title,
  titleLine1,
  titleLine2,
}: BrandHeroTitleProps) {
  return (
    <>
      <span className="md:hidden">
        <ScrollRevealText variant="dark" mode="whole">
          {titleLine1}
          <br />
          {titleLine2}
        </ScrollRevealText>
      </span>
      <span className="hidden md:contents">
        <ScrollRevealText variant="dark">{title}</ScrollRevealText>
      </span>
    </>
  );
}
